import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { FormFieldProperty } from "../../../models/form-field-property";
import { FieldPropertiesControllerService } from "../../../services/crossed-tables/field-properties-controller.service";
import {ResizeEvent} from "angular-resizable-element";
import { BaseError } from "../base-error";
import { FormControllerService } from "../../../services/form-controller/form-controller.service";

@Component({
  selector: "field-properties-tables",
  templateUrl: "field-properties.component.html",
  styles: [".cursor-hand {cursor: pointer;}"],
  providers: [FieldPropertiesControllerService, ToastrService, FormControllerService],
})
export class FieldPropertiesComponent extends BaseError implements OnInit {
  public formFieldProperties: FormFieldProperty[][] = [];
  public serviceId: string;
  public tableSwitched: boolean = false;
  public showFieldsGenerator: boolean = false;
  public style: object = {};
  public formFieldsGroup: any[] = [];
  @Output() public modalClosedEvent = new EventEmitter();

  constructor(private fieldPropertiesControllerService: FieldPropertiesControllerService,
              private route: ActivatedRoute,
              toastr: ToastrService,
              private formControllerService: FormControllerService) {
    super(toastr);
  }

  public ngOnInit() {
    this.route.params.subscribe((params) => {
      this.serviceId = params.serviceId;
    });
    this.getFieldProperties();
  }

  public getFieldProperties() {
    this.fieldPropertiesControllerService.getFieldPropertiesList(this.serviceId).subscribe(
      (data) => {
        this.formFieldProperties = data;
        this.switchHeadings();
        this.formControllerService.getFilteredFormFields(this.serviceId, null, true, true, false, false, false, true, false).subscribe(
          (fdata) => {
            this.formFieldsGroup = this.replaceRowsAndColumnsWithComponents(fdata);
          });
      },
      (error) => this.showErrorMessage(error),
    );
  }

  private replaceRowsAndColumnsWithComponents(components: any[]): any[] {
    return components.map(component => {
      if (component.rows && component.type === "table") {
        component.components = this.replaceRowsAndColumnsWithComponents(this.getComponentsForRows(component.rows));
        delete component.rows;
      }

      if (component.columns && component.type === "columns") {
        component.components = this.replaceRowsAndColumnsWithComponents(this.getComponentsForColumns(component.columns));
        delete component.columns;
      }

      if (component.components) {
        component.components = this.replaceRowsAndColumnsWithComponents(component.components);
      }
      return component;
    });
  }

  private getComponentsForRows(rows: any[]) {
    const components = [];
    if (Array.isArray(rows)) {
      rows.forEach(row => {
        if (Array.isArray(row)) {
          row.forEach((r: any) => {
            if (r.components && Array.isArray(r.components)) {
              r.components.forEach((component: any) => {
                components.push(component);
              });
            }
          });
        }
      });
    }

    return components;
  }

  private getComponentsForColumns(columns: any[]) {
    const components = [];
    if (Array.isArray(columns)) {
      columns.forEach(column => {
        components.push(column);
      });
    }
    return components;
  }

  public switchHeadings() {
    this.tableSwitched = !this.tableSwitched;
    const switchedEntries = [];
    if (this.formFieldProperties[0]) {
      for (let j = 0; j < this.formFieldProperties[0].length; j++) {
        const newRow = [];
        for (let i = 0; i < this.formFieldProperties.length; i++) {
          newRow.push(this.formFieldProperties[i][j]);
        }
        switchedEntries.push(newRow);
      }
    }
    this.formFieldProperties = switchedEntries;
  }

  public onResizeEnd(event: ResizeEvent) {
    this.style = {
      width: `${event.rectangle.width}px`,
    };
  }

}
